import { UiLinkBlockModel } from "../../models";

import { mockUiBlockModel, mockUiBlockModelContent } from "./mock-ui-block";

export function mockUiLinkBlockModel({
    id = "link-block-1234",
    type = "uiLinkBlock",
    locale = "en",
    content = mockUiLinkBlockModelContent()
}: Partial<UiLinkBlockModel> = {}): UiLinkBlockModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiLinkBlockModelContent = UiLinkBlockModel["content"];

export function mockUiLinkBlockModelContent({
    entryTitle = "Example link block",
    title = "Go to Trello",
    url = "https://trello.com/home",
    block = mockUiBlockModel({ content: mockUiBlockModelContent() }),
    ...optionals
}: Partial<UiLinkBlockModelContent> = {}): UiLinkBlockModelContent {
    return {
        entryTitle,
        title,
        url,
        block,
        ...optionals
    };
}
